export const stepsTheme = {
  extend: {
    custom: {
      numberSize: "2rem",
      numberBorderWidth: "1px",
      numberBorderColor: "{primary.200}",
      numberBackground: "{surface.0}",
      numberColor: "{primary.600}",
      activeNumberBackground: "{primary.color}",
      activeNumberBorderColor: "{primary.color}",
      activeNumberColor: "#ffffff",
      labelColor: "{primary.600}",
      activeLabelColor: "{primary.700}",
      labelFontSize: "0.95rem",
      labelFontWeight: "500",
      activeLabelFontWeight: "700",
      itemGap: ".5rem"
    }
  },
  css: ({ dt }: { dt: (token: string) => string }) => `
    .p-steps {
      width: 100%;
    }

    .p-steps .p-steps-list {
      align-items: flex-start;
    }

    .p-steps .p-steps-item-link {
      background: transparent;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: ${dt("steps.custom.itemGap")};
      text-decoration: none;
    }

    .p-steps .p-steps-item-number {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: ${dt("steps.custom.numberSize")};
      min-width: ${dt("steps.custom.numberSize")};
      height: ${dt("steps.custom.numberSize")};
      border-radius: 9999px;
      border: ${dt("steps.custom.numberBorderWidth")} solid ${dt("steps.custom.numberBorderColor")};
      background: ${dt("steps.custom.numberBackground")};
      color: ${dt("steps.custom.numberColor")};
      font-weight: 600;
      line-height: 1;
    }

    .p-steps .p-steps-item-label {
      color: ${dt("steps.custom.labelColor")};
      font-size: ${dt("steps.custom.labelFontSize")};
      font-weight: ${dt("steps.custom.labelFontWeight")};
      text-align: center;
      line-height: 1.2;
      margin: 0;
    }

    .p-steps .p-steps-item-active .p-steps-item-number {
      background: ${dt("steps.custom.activeNumberBackground")};
      border-color: ${dt("steps.custom.activeNumberBorderColor")};
      color: ${dt("steps.custom.activeNumberColor")};
    }

    .p-steps .p-steps-item-active .p-steps-item-label {
      color: ${dt("steps.custom.activeLabelColor")};
      font-weight: ${dt("steps.custom.activeLabelFontWeight")};
    }
  `,
};
